import {
  BO_CARD_VALUE,
  BO_DATA_DOWNLOAD,
  BO_DIVISION_VALUE,
  BO_GRAPH_VALUE,
  BO_LOCATION_DOWNLOAD,
  BO_RANGE,
  BO_TABLE_DATA,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getBORange = (
  location,
  division,
  department,
  vendor,
  timeline
) => {
  const requestURL = BO_RANGE;
  let obj = { timeline: timeline };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCardValue = (
  location,
  division,
  department,
  vendor,
  timeline,
  days,
  rangeValue
) => {
  const requestURL = BO_CARD_VALUE;
  let obj = { timeline: timeline };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }
  if (days && days.length) {
    obj["days"] = days.join(",");
  }
  if (rangeValue) {
    obj["range_value"] = rangeValue;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getBODivisionValue = (
  location,
  division,
  department,
  vendor,
  timeline,
  days,
  rangeValue
) => {
  const requestURL = BO_DIVISION_VALUE;
  let obj = { timeline: timeline };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }
  if (days && days.length) {
    obj["days"] = days.join(",");
  }
  if (rangeValue) {
    obj["range_value"] = rangeValue;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getBOGraphValue = (
  aggr,
  location,
  division,
  department,
  vendor,
  timeline,
  days,
  rangeValue,
  page,
  limit,
  sort
) => {
  const requestURL = BO_GRAPH_VALUE;
  let obj = { group_by: aggr, timeline: timeline };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }
  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }
  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }
  if (days && days.length) {
    obj["days"] = days.join(",");
  }
  if (rangeValue) {
    obj["range_value"] = rangeValue;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit, sort: sort },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getBOTableData = (
  location,
  division,
  department,
  vendor,
  timeline,
  days,
  rangeValue,
  page,
  limit,
  sort,
  sort_by
) => {
  const requestURL = BO_TABLE_DATA;
  let obj = {
    sort_by: sort_by,
    sort: sort,
    timeline: timeline,
  };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (days && days.length) {
    obj["days"] = days.join(",");
  }

  if (rangeValue) {
    obj["range_value"] = rangeValue;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getBOPartReport = (
  location,
  division,
  department,
  vendor,
  timeline,
  days,
  rangeValue
) => {
  const requestURL = BO_DATA_DOWNLOAD;
  let obj = {
    timeline: timeline,
  };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }
  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (days && days.length) {
    obj["days"] = days.join(",");
  }

  if (rangeValue) {
    obj["range_value"] = rangeValue;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getBOLocationReport = (location) => {
  const requestURL = BO_LOCATION_DOWNLOAD;
  let obj = {location: location};

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
